import { UploadFile } from "antd";
import GeneralInformation, {
  updateGeneralInformationDTO,
} from "../interfaces/general-information.interface";
import http from "./axios";
import {
  addFilesToBody,
  convertObjectToFormData,
  downloadFile,
  handleError,
} from "./http-utils.service";

type GeneralInformationResponse = {
  success: boolean;
  data: {
    generalInformation: GeneralInformation;
    createResults: string | undefined;
    deleteResults: string | undefined;
  };
};

export const updateGeneralInfo = async (
  { info, files }: { info: updateGeneralInformationDTO; files: UploadFile[] },
  id: number,
) => {
  try {
    const formData = convertObjectToFormData(info);
    addFilesToBody(formData, files);
    const response = await http.patch<GeneralInformationResponse>(
      `/general-info/${id}`,
      formData,
      {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      },
    );
    return response.data;
  } catch (e) {
    throw handleError(e);
  }
};

export const getGeneralInfoById = async (id: string = "") => {
  try {
    const response = await http.get<GeneralInformation>(`/general-info/${id}`);
    return response.data;
  } catch (e) {
    throw handleError(e);
  }
};

export const getGeneralInfoByInstitutionId = async (id: string = "") => {
  try {
    const response = await http.get<GeneralInformation>(
      `institutions/${id}/general-information`,
    );
    return response.data;
  } catch (e) {
    throw handleError(e);
  }
};

export const downloadFileById = async (id: string = "", name: string) => {
  if (name === "") return false;
  try {
    const response = await http.get<{ url: string }>(
      `/general-attached-files/${id}/file`,
      {
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    const res = await http.get<Blob>(response.data.url, {
      responseType: "blob",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
    });
    downloadFile(res.data, name);
    return res.data;
  } catch (e) {
    throw handleError(e);
  }
};
